export const getInitials = (name: string) => {
  return name
    ?.replace(/[a-z]/g, ' ')
    ?.replace(/[-,./]/g, '')
    .split(' ')
    .reduce((acc, cur) => acc + cur.trim(), '')
    .slice(0, 5);
};
